import { render, staticRenderFns } from "./LandSuitabilityReportDetails.vue?vue&type=template&id=5bf12972&scoped=true"
import script from "./LandSuitabilityReportDetails.vue?vue&type=script&lang=js"
export * from "./LandSuitabilityReportDetails.vue?vue&type=script&lang=js"
import style0 from "./LandSuitabilityReportDetails.vue?vue&type=style&index=0&id=5bf12972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf12972",
  null
  
)

export default component.exports